import React from "react";
import UserContext from './usercontext.jsx';

import TablePagination from '@mui/material/TablePagination';
import Grid from '@mui/material/Grid';

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';

class TowerMissionData extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            error: null,
            isLoaded: false,
            items: [],
            page: { rowsPerPage: 10 }
        };
        this.setState = this.setState.bind(this);
        this.onChangePage = this.onChangePage.bind(this);
        this.onChangeRowsPerPage = this.onChangeRowsPerPage.bind(this);
    }



    componentDidMount() {
        getPage("/web/towersmissiondata", {}, this.setState);
    }

    onChangePage(event, pageNum){
        var rowsPerPage = this.state.page.rowsPerPage;
        this.setState({ isLoaded: false });
        getPage("/web/towersmissiondata", { page: pageNum, size: rowsPerPage }, this.setState);
    }

    onChangeRowsPerPage(event){
        this.setState({ isLoaded: false });
        getPage("/web/towersmissiondata", { size: event.target['value'] }, this.setState);
    }


    render() {
        const { error, isLoaded, items } = this.state;
        if (error) {
            return <div style={{ background: '#ffffff', border: '2px solid #dfdfdf' }}>Error: {error.message}</div>;
        } else if (!isLoaded) {
            return <div className="text-center" style={{ background: '#ffffff', border: '2px solid #dfdfdf' }}><div className="spinner-border m-5" /></div>;
        } else {
            return (
                <UserContext.Consumer>
                    {user => (
                        <div style={{ background: '#ffffff', border: '2px solid #dfdfdf', marginTop: 20 }}>
                            <Grid container spacing={0}>
                                <Grid item xs={6} sm={6} style={{ padding: 20 }}>
                                    <h2>Mission values</h2>
                                </Grid>
                                <Grid item xs={6} sm={6} style={{ padding: 20, textAlign: "right" }}>

                                </Grid>
                            </Grid>
                            <Table padding="dense">
                                <TableHead>
                                    <TableRow>
                                        <TableCell>Tower number</TableCell>
                                        <TableCell>Base width</TableCell>
                                        <TableCell>Height from takeoff point</TableCell>
                                        <TableCell>Equipment levels</TableCell>
                                        <TableCell>Last updated</TableCell>
                                        <TableCell>Updated by</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {items.map(tower => (
                                        <TableRow key={tower.number}>
                                            <TableCell>{tower.number}</TableCell>
                                            <TableCell>{Math.round(tower.width)} ft</TableCell>
                                            <TableCell>{Math.round(tower.height)} ft</TableCell>
                                            <TableCell>{(tower.equipmentLevels || []).join(' / ')}</TableCell>
                                            <TableCell>{tower.updateTime}</TableCell>
                                            <TableCell>{tower.updateAuthor}</TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                            <TablePagination
                                rowsPerPageOptions={[10, 20, 30]}
                                component="div"
                                count={this.state.page.totalElements}
                                rowsPerPage={this.state.page.rowsPerPage}
                                page={this.state.page.pageNumber}
                                backIconButtonProps={{
                                    'aria-label': 'Previous Page',
                                }}
                                nextIconButtonProps={{
                                    'aria-label': 'Next Page',
                                }}
                                onPageChange={this.onChangePage}
                                onRowsPerPageChange={this.onChangeRowsPerPage}
                            />
                        </div>
                    )}
                </UserContext.Consumer>
            )
        }
    }
}


export default TowerMissionData;